module.exports = __webpack_public_path__ + "media/images/wf_logo.2-4c01bd0203a8648d3c3bafc1f5df35e0.png";